export default __webpack_public_path__ + "static/media/mollette.9eb136b6.gif";